// Calculadoras clínicas. As constantes vêm da ficha da fórmula (formulas.json),
// por espécie; sem constante conferida para a espécie, a calculadora não roda.

export type KFluidos = { lin: number; alo: number };
export type KRer = { fatores: [string, number, number][] };
export type KTransfusao = { vsMin: number; vsMax: number; regra?: number };
export type KChoque = { min: number; max: number; tempo: string };

export function fluidos(K: KFluidos, peso: number, desidPct = 0, perdasMlDia = 0) {
  const manutencao = [
    { rotulo: `${K.lin} mL/kg/dia`, mlDia: K.lin * peso },
    { rotulo: `${K.alo} × kg^0,75`, mlDia: K.alo * peso ** 0.75 },
    { rotulo: "30 × kg + 70", mlDia: 30 * peso + 70 },
  ].map((m) => ({ ...m, mlH: m.mlDia / 24 }));
  return { manutencao, deficitMl: peso * (desidPct / 100) * 1000, perdasMl: perdasMlDia };
}

export function rer(K: KRer, peso: number) {
  const kcal = 70 * peso ** 0.75;
  return { kcal, mer: K.fatores.map(([rotulo, a, b]) => ({ rotulo, a, b, lo: kcal * a, hi: kcal * b })) };
}

/** null quando o Ht desejado não é maior que o do paciente. */
export function transfusao(K: KTransfusao, peso: number, htPac: number, htAlvo: number, htDoador: number) {
  if (!htPac || !htAlvo || !htDoador || htAlvo <= htPac) return null;
  const fr = (htAlvo - htPac) / htDoador;
  return {
    lo: peso * K.vsMin * fr,
    hi: peso * K.vsMax * fr,
    regraMl: K.regra ? K.regra * (htAlvo - htPac) * peso : undefined,
  };
}

/** Área de superfície corporal em m², com K da espécie e peso em g. */
export const bsa = (K: number, peso: number) => (K * (peso * 1000) ** (2 / 3)) / 10000;

/** Velocidade da bomba em mL/h para dose em mg/kg/h. */
export const cri = (peso: number, doseMgKgH: number, concMgMl: number) => (doseMgKgH * peso) / concMgMl;

export const choque = (K: KChoque, peso: number) => ({ lo: K.min * peso, hi: K.max * peso, tempo: K.tempo });
